import React, { FC, ReactNode } from 'react';
import classnames from 'classnames';

import { Link } from 'dibs-elements/exports/Link';
import { trackFooterNavigationClick } from '../../../helpers/trackingHelpers';

import styles from './LinkColumnItem.scss';

type Props = {
    message: ReactNode;
    trackingLabel: string;
    href: string;
    target?: '_blank';
    dataTn?: string;
    badgeText?: ReactNode;
    isLegalLink?: boolean;
};
const LinkColumnItem: FC<Props> = ({
    target,
    trackingLabel,
    href,
    dataTn,
    message,
    badgeText,
    isLegalLink,
}) => {
    const doNotShowPrivacyPolicyAlerts = true;
    const shouldShowBadge = !!badgeText && !doNotShowPrivacyPolicyAlerts;

    return (
        <li className={classnames(styles.item, { [styles.isLegalLink]: !!isLegalLink })}>
            {href ? (
                <Link
                    buyerLinkType="contrastLinkLight"
                    target={target}
                    href={href}
                    onClick={() => trackFooterNavigationClick({ label: trackingLabel })}
                    dataTn={dataTn}
                >
                    {message}
                    {shouldShowBadge && <div>{badgeText}</div>}
                </Link>
            ) : (
                message
            )}
        </li>
    );
};
export default LinkColumnItem;
